import React, { useCallback, useRef } from 'react';

// this function returns RefObject for a given Ref.
// It handles the case where the passed ref prop can be null.
export function useRefProp<T>(refProp?: React.Ref<T>) {
  const innerRef = useRef<T>(undefined);

  const refCallback = useCallback(
    (el: T | null) => {
      innerRef.current = el || undefined;
      if (!refProp) return;
      if (typeof refProp === 'function') {
        refProp(el);
      } else {
        refProp.current = el;
      }
    },
    [refProp]
  );
  return { refCallback, innerRef: innerRef as React.RefObject<T> };
}
